// extracted by css-extract-rspack-plugin
export default {"row":"row-FUCnpB","rowLabel":"rowLabel-bQzk6F","rowValue":"rowValue-SL21AZ","copiedIcon":"copiedIcon-DWgGLa"};